<template>
  <div>
    <el-drawer
      v-model="visible"
      append-to-body
      class="follow-record-drawer"
      destroy-on-close
      direction="btt"
      :show-close="false"
      size="77%"
      :with-header="false"
    >
      <div class="fr-drawer-header">
        <i class="icon-close-large-line t-iconfont" @click="getClose"></i>
        {{ title }}
      </div>
      <div class="fr-drawer-center">
        <Core
          :device-info="deviceInfo"
          :is-quick="false"
          @handleSendRecordCard="handleSendRecordCard"
        />
      </div>
      <div v-if="isVisit" class="fr-drawer-footer">
        <div
          class="fr-drawer-footer__btn"
          :class="{ 'fr-drawer-footer__btn-loading': loading }"
          @click="handleStartRecord"
        >
          <i class="fr-drawer-footer__btn-icon icon-mic-ai-line t-iconfont"></i>
          <span class="fr-drawer-footer__btn-text">{{
            loading ? '录音开始中...' : '开始录音'
          }}</span>
        </div>
      </div>
    </el-drawer>
    <!-- 本地上传 -->
    <RecordUpload
      v-if="recordUploadVisible"
      v-model:record-upload-visible="recordUploadVisible"
      :ai-audio-id="aiAudioId"
      :audio-url="audioUrl"
      :audio-url-blob="audioUrlBlob"
      :is-ai="true"
      :is-visit="isVisit"
      title="智能硬件录音导入"
      :upload-time="uploadTime"
      :visit-item="visitItem"
      @getAiLIst="getAiLIst"
      @getClose="getClose"
    ></RecordUpload>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import RecordUpload from '@/components/follow-record/record-upload.vue'
import Core from '@/pages/ai-board/components/third-import-dialog/components/core.vue'

defineOptions({
  name: 'RecordAiUpload'
})

const props = defineProps({
  recordAiUploadVisible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '选择智能硬件录音'
  },
  // 设备启用信息
  deviceInfo: {
    type: Object,
    default: () => ({})
  },
  isVisit: {
    type: Boolean,
    default: false
  },
  visitItem: {
    type: Object,
    default: () => ({})
  }
})

const emits = defineEmits(['update:recordAiUploadVisible', 'handleStartRecord'])

const recordUploadVisible = ref(false)
const audioUrl = ref('')
const audioUrlBlob = ref('')
const uploadTime = ref('')
const aiAudioId = ref('')

const loading = ref(false)

const visible = computed({
  get: () => props.recordAiUploadVisible,
  set: (val) => {
    emits('update:recordAiUploadVisible', val)
  }
})

/**
 * 处理录音发送
 * @param recordInfo 录音信息
 */
const handleSendRecordCard = (recordInfo) => {
  // emits('handleSendRecord', recordInfo)
  console.log('智能导入，选中了录音', recordInfo)
  audioUrl.value = recordInfo?.fileUrl
  audioUrlBlob.value = recordInfo?.fileUrl
  // 上传时间
  uploadTime.value = recordInfo?.startTime
  aiAudioId.value = recordInfo.id
  // 赋值完成后打开弹窗
  recordUploadVisible.value = true
  visible.value = false
}

const getClose = () => {
  visible.value = false
}

const handleStartRecord = () => {
  loading.value = true
  const cb = () => {
    loading.value = false
  }
  emits('handleStartRecord', cb)
}

const getAiLIst = () => {
  visible.value = true
}

onMounted(() => {})
</script>

<style lang="scss">
.follow-record-drawer {
  border-radius: 24px 24px 0px 0px;
  .el-drawer__body {
    display: flex;
    flex-direction: column;
    border-radius: 24px 24px 0px 0px;
    display: flex;
    flex-direction: column;
    // overflow: hidden;
  }
  .fr-drawer-header {
    flex: 0 0 auto;
    height: 48px;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    line-height: 48px;
    position: relative;
    .icon-close-large-line {
      position: absolute;
      left: 24px;
      color: #c9cdd4;
    }
  }
  .fr-drawer-center {
    flex: 1;
    padding: 12px;
    box-sizing: border-box;
    overflow-y: auto;
    .audio-player__play {
      margin: 0 14px 0 0 !important;
    }
    .icon-play-circle-fill,
    .icon-pause-circle-fill {
      font-size: 20px !important;
    }
    .record-item__header {
      margin-bottom: 0px !important;
    }
    .record-item {
      padding: 12px 12px 6px 12px !important;
    }
    .el-slider {
      margin-left: 5px !important;
    }
  }
  .fr-drawer-footer {
    flex: 0 0 auto;
    padding: 12px;
    margin-bottom: env(safe-area-inset-bottom);
    .fr-drawer-footer__btn {
      height: 34px;
      border-radius: 64px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border: 1px solid #7a52f4;
      color: #7a52f4;
      .fr-drawer-footer__btn-icon {
        font-size: 14px;
        margin-right: 8px;
      }
      .fr-drawer-footer__btn-text {
        font-size: 13px;
        line-height: 18px;
      }
    }
    .fr-drawer-footer__btn-loading {
      opacity: 0.6;
    }
  }
}
</style>
